import { ONBOARDING_TRIGGERS } from "@/constants/onboarding";

export function TriggersScreen() {
	return (
		<div className="space-y-6">
			{/* Heading */}
			<div className="space-y-3 text-center">
				<h2 className="text-2xl font-semibold tracking-tight">Choose when work gets done</h2>
			</div>

			{/* Trigger Types */}
			<div className="space-y-3">
				{ONBOARDING_TRIGGERS.map((trigger) => {
					const Icon = trigger.icon;
					return (
						<div key={trigger.title} className="space-y-4 rounded-lg border bg-card p-5">
							<div className="flex items-start gap-4">
								<div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
									<Icon className="size-5" />
								</div>
								<div className="min-w-0 flex-1">
									<h4 className="text-base font-semibold">{trigger.title}</h4>
									<p className="text-sm text-muted-foreground">{trigger.description}</p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
